// extracted by mini-css-extract-plugin
module.exports = {"sidenav":"multisidebar-module__sidenav___o5dfH","sidenavContainer":"multisidebar-module__sidenavContainer___3QO86","noProductCard":"multisidebar-module__noProductCard___2ajvS"};